import { connect } from 'react-redux'
import React, { PureComponent } from 'react'
import TeacherGame, { ISkin } from '../../views/teacherGame/TeacherGame'
import { bindActionCreators, AnyAction, Dispatch } from 'redux'
import viewSelector from '../../redux/selectors/game/viewSelector'

import withTransition from '../../hoc/Transition'
import withRendererFilter from '../../hoc/RendererFilter'
import { ISize } from '../../helpers/data/size'
import questionActions from '../../redux/actions/questionActions'
import appActions from '../../redux/actions/appActions'
import { IGameActivity } from '../../helpers/data/question'
import { IPlayerData, IPlayerWithCurrentNumberOfCorrectAnswer } from '../../helpers/data/player'
import { IMountainPlayerData } from '../../helpers/data/mountainPlayer'
import viewTypes from '../../helpers/enums/views'
import { IStore } from '../../redux/reducers/index'

interface IGameProps {
	isFinished: boolean
	playerData: IPlayerData
	players: IMountainPlayerData[]
	activity: IGameActivity
	totalActivities: number
	totalTime: number
	size: ISize
	skin: ISkin
	elapsedTime: number
	shouldSeeNewTeacherDashboard: boolean
	shouldHideStudentNames: boolean
	getCurrentNumberOfCorrectAnswersByParticipants: () => void
	moveToNextActivity: () => void
	audioUpdate: () => void
	isPauseEnabledSetting: boolean
	isTimerDisabledSetting: number
	studentsIDWithNumberOfCorrectAnswersFromServer: IPlayerWithCurrentNumberOfCorrectAnswer[] | undefined
	volume: number
	isMuted: boolean
	gameMode: number
}

class TeacherGameConnector extends PureComponent<IGameProps> {
	render() {
		return (
			<TeacherGame
				players={this.props.players}
				activity={this.props.activity}
				totalActivities={this.props.totalActivities}
				totalTime={this.props.totalTime}
				elapsedTime={this.props.elapsedTime}
				isFinished={this.props.isFinished}
				playerData={this.props.playerData}
				size={this.props.size}
				skin={this.props.skin}
				shouldHideStudentNames={this.props.shouldHideStudentNames}
				getCurrentNumberOfCorrectAnswersByParticipants={this.props.getCurrentNumberOfCorrectAnswersByParticipants}
				studentsIDWithNumberOfCorrectAnswersFromServer={this.props.studentsIDWithNumberOfCorrectAnswersFromServer}
				moveToNextActivity={this.props.moveToNextActivity}
				audioUpdate={this.props.audioUpdate}
				isPauseEnabledSetting={this.props.isPauseEnabledSetting}
				isTimerDisabledSetting={this.props.isTimerDisabledSetting}
				volume={this.props.volume}
				isMuted={this.props.isMuted}
				gameMode={this.props.gameMode}
			/>
		)
	}
}

const mapStateToProps = (state: IStore) => {
	return viewSelector(state)
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
	return bindActionCreators(
		{
			getCurrentNumberOfCorrectAnswersByParticipants: questionActions.getCurrentNumberOfCorrectAnswersByParticipants,
			moveToNextActivity: appActions.moveToNextActivity,
			audioUpdate: appActions.audioUpdate,
		},
		dispatch
	)
}

export default withTransition(
	connect(mapStateToProps, mapDispatchToProps)(withRendererFilter(TeacherGameConnector, viewTypes.TEACHER_GAME))
)
